import { timeToMinutes } from 'src/helpers/timeToMinutes/timeToMinutes';

interface ITimeSpan {
  startTime: string;
  endTime: string;
}

const MINUTES_PER_DAY = 24 * 60;

// end_time is inclusive of its final minute, so duration is (end - start + 1).
const getDurationMinutes = ({ startTime, endTime }: ITimeSpan): number =>
  Math.max(0, timeToMinutes(endTime) - timeToMinutes(startTime) + 1);

// Share of a fixed 1440-minute day, not the sum of durations present - so a gap shows as a short
// bar instead of being silently stretched to fill 100%.
export const getDayPercents = (items: ITimeSpan[]): number[] =>
  items.map((item) => (getDurationMinutes(item) / MINUTES_PER_DAY) * 100);
